module.exports = __webpack_public_path__ + "img/exceed-safe-time-in-pad.409ced54.svg";